module.exports = __webpack_public_path__ + "img/9.0d1c2ff1.png";